import { Component, EventEmitter, Output, ViewChild, ElementRef } from "@angular/core";

@Component({
  selector: "app-file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"],
  standalone: false,
})
export class FileUploadComponent {
  @ViewChild("fileInput") fileInput!: ElementRef<HTMLInputElement>;
  @Output() fileUpload = new EventEmitter<Event>();

  // Match the default values from upload-modal.component.ts
  readonly maxFileSizeLabel: string = "200 MB";
  readonly maxFileSize: number = 209715200; // 200 MB in bytes
  readonly allowedFileTypes: string =
    "TXT, CSV, PDF, DOC, DOCX, ODT, PPTX, PPT, RTF, XLS, XLSX, XLSM, PNG, JPEG, JPG, GIF, BMP, ZIP";

  errors: string[] = [];

  onFileUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.errors = [];

    if (!input.files || input.files.length === 0) {
      return;
    }

    let hasErrors = false;
    const files = Array.from(input.files);

    // Validate each file
    for (const file of files) {
      if (!this.isValidFile(file)) {
        hasErrors = true;
      }
    }

    // If there are errors, clear the input and don't emit the event
    if (hasErrors) {
      input.value = "";
      return;
    }

    // If all files are valid, emit the event
    this.fileUpload.emit(event);
  }

  private isValidFile(file: File): boolean {
    if (!(file && file.name)) {
      this.errors.push(`Invalid file or files`);
      return false;
    }

    const ext = file.name.split(".").slice(-1)[0];
    if (!ext) {
      this.errors.push(`Cannot determine file type`);
      return false;
    }

    if (!this.allowedFileTypes.toLowerCase().includes(ext.toLowerCase())) {
      this.errors.push(`File type '${ext}' is not supported`);
      return false;
    }

    if (file.size === 0) {
      this.errors.push(`File cannot be empty: ${file.name}`);
      return false;
    }

    if (file.size > this.maxFileSize) {
      this.errors.push(
        `File cannot be larger than ${this.maxFileSizeLabel}: ${file.name}`
      );
      return false;
    }

    return true;
  }
}

